import React, { useState } from "react";
import DomainResults from "./DomainResults";
import { domainData } from "./Data";
import { CreateBar } from "./CreateBar";
import { Button } from "react-bootstrap";
import "./OverallResult.css";

function Overall(props) {
  const [showDomains, setShowDomains] = useState(false);

  function CreateOverall(props) {
    function handleClick() {
      if (!showDomains) {
        setShowDomains(true);
      } else {
        setShowDomains(false);
      }
    }
    return (
      <div>
        <p>
          The test measured the level of stress you’ve experienced in the past
          one year, and your scores can be interpreted as an overall{" "}
          <strong>{props.resultOverall}</strong>.
        </p>
        <p>
          The test also accessed some domains in your life. Read ahead to find
          out the level of stress you’ve experienced in each of these domains.
        </p>
        <div className="bars-div">
        <div className="legend">
          <div className="low" />
          Low Stress
          <div className="average" />
          Average Stress
          <div className="high" />
          High Stress
        </div>
          <CreateBar percentage={props.results[0]} domainName="Financial" color={domainData[0].color} />
          <CreateBar percentage={props.results[1]} domainName="Family" color={domainData[1].color} />
          <CreateBar percentage={props.results[2]} domainName="Social" color={domainData[2].color} />
          <CreateBar percentage={props.results[3]} domainName="Education" color={domainData[3].color} />
          <CreateBar percentage={props.results[4]} domainName="Ego Threat" color={domainData[4].color} />
          <CreateBar percentage={props.results[5]} domainName="Bereavement" color={domainData[5].color} />
          <CreateBar percentage={props.results[6]} domainName="Separation" color={domainData[6].color} />
          <CreateBar
            percentage={props.results[7]}
            domainName="Personal Setback"
            color={domainData[7].color}
          />
          <CreateBar
            percentage={props.results[8]}
            domainName="Health of Others"
            color={domainData[8].color}
          />
        </div>
        <Button variant="secondary" onClick={handleClick}>
          Detailed Results
        </Button>
      </div>
    );
  }
  return (
    <div>
      {console.table(props.results)}
      <CreateOverall
        resultOverall={props.resultOverall}
        results={props.results}
      />
      {showDomains ? (
        <div>
          <DomainResults />
        </div>
      ) : null}
    </div>
  );
}

export default Overall;
